import React from 'react'
import { Tag } from 'antd'
import { get, groupBy } from 'lodash'
import moment from 'moment'
import { Text } from '../../common'
import OrderPickerManager from './OrderPickerManager'
// Shopper -> Picker asignado (si no hay, mostrar vacío)

// Total descuentos ->value (apartado Total de descuentos)

// Total solicitado ->value (apartado Total de los items)

// Total comprado -> basado en el resultado del picking

// Liberación de reserva -> creationDate + 10 días
const OrderCardMetadata = (props) => {
  const totals = groupBy(get(props, 'totals', []), 'id')
  return {
    title: <div><Text strong text='Picking' /></div>,

    subtitle: (subtitle = 'Jumbo Los Domínicos') =>
      <div className=''>
        <Text tiny subtitle text='order_detail.picking_criteria' />
        <span className='separator tiny'>|</span>
        <Text tiny subtitle text='order_detail.picking_mode' />
      </div>,
    info: () => (
      <div style={{ height: 50, marginTop: 5, display: 'flex', justifyContent: 'space-around', paddingTop: 5, paddingBottom: 5 }}>
        {[{ value: 1, status: 'Pedidos' },
          { value: 1, status: 'Pickeados' },
          { value: 1, status: 'Sustituidos' }
        ].map(({ value, status }, index) =>
          (<div key={index} style={{ textAlign: 'center', fontWeight: 'bold' }}>
            <div><span>{value}</span></div>
            <div><span>{status}</span></div>
          </div>)
        )}
      </div>
    ),
    extra: ({ status, color } = { status: 'status', color: '#1fa02e' }) => (
      <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }} >
        <Tag color={color} >{status}</Tag>
      </div>),
    extra_info: [
      { title: <Text tiny text='Shopper' />, value: <OrderPickerManager {...props} /> },
      { title: <Text tiny text='Total Descuentos' />, value: <Text tiny text={`$ ${get(totals, 'discounts.0.value')}`} /> },
      { title: <Text tiny text='Total Solicitado' />, value: <Text tiny text={`$ ${get(totals, 'items.0.value')}`} /> },
      { title: <Text tiny text='Total Comprado' />, value: <Text tiny text={`$ 0`} /> },
      { title: <Text tiny text='Liberación de Reserva' />, value: <Text tiny text={moment(get(props, 'createdAt')).add('10', 'days').format('DD/MM/YYYY HH:mm')} /> }
    ],
    footer: () => {
      return (
        <div className='flex justify-content-space-around align-items-center'>
          <a><Text text='order_detail.history' /></a>
          <a><Text text='order_detail.log_call' /></a>
        </div>
      )
    }
  }
}

export default OrderCardMetadata
